import React, { useState } from 'react';

import StringUtils from '../utils/stringUtils';
import fetchUrlFromCDN from '../service/cdnService';
import isEmpty from 'lodash.isempty';
import queryString from 'query-string';

export const BrandLogoContext = React.createContext<{
  brandImages: LeadBrandLogo | undefined;
}>({
  brandImages: undefined,
});

export type LeadBrandLogo = {
  logo: string;
  brand: string;
};

const isBrowser = typeof document !== 'undefined';

function getCookie(name: string): string | undefined {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length >= 2) {
    return parts.pop()?.split(';').shift();
  }
  return '';
}

export default function LeadBrandContextProvider({
  children,
}: {
  children: React.ReactNode | React.ReactNode[];
}) {
  const [brandImages, setBrandImages] = useState<LeadBrandLogo>({
    brand: '',
    logo: getCookie('brandURL') || '',
  });
  console.log('Browser Context');
  React.useEffect(
    () => {
      if (isBrowser) {
        const { leadBrand } = queryString.parse(document.location.search);
        let leadBrandText =
          leadBrand && !StringUtils.isQueryParamEmpty(leadBrand)
            ? Array.isArray(leadBrand) && leadBrand[0]
              ? leadBrand[0].toString()
              : leadBrand.toString()
            : '';

        if (isEmpty(brandImages.logo))
          fetchUrlFromCDN(leadBrandText)
            .then((response: LeadBrandLogo) => {
              'logo' in response && setBrandImages(response);
            })
            .catch((error: any) => {
              console.log(error);
            });
      }
    },
    isBrowser ? [document.location.search] : []
  );

  return (
    <BrandLogoContext.Provider value={{ brandImages: brandImages }}>
      {children}
    </BrandLogoContext.Provider>
  );
}
